import type { $Fetch } from "ofetch"

import AuthModule from "@/api/resources/auth"

export default (fetcher: $Fetch) => ({
  auth: new AuthModule(fetcher)
})
